<template>
  <ion-page>
    <ion-tabs>
      <ion-router-outlet></ion-router-outlet>

      <ion-tab-bar slot="bottom" style="box-shadow: 0 24px 25px 18px rgba(0,0,0,0.45);">
        <ion-tab-button tab="home-page" href="/home-page">
          <ion-icon aria-hidden="true" :icon="homeOutline" />
          <ion-label>{{$t("navbar.home")}}</ion-label>
        </ion-tab-button>

        <ion-tab-button tab="contracts-page" href="/contracts-page">
          <ion-icon aria-hidden="true" :icon="personOutline" />
          <ion-label>{{$t("navbar.contracts")}}</ion-label>
        </ion-tab-button>

        <ion-tab-button tab="settings-page" href="/settings-page">
          <ion-icon aria-hidden="true" :icon="settingsOutline" />
          <ion-label>{{$t("navbar.settings")}}</ion-label>
        </ion-tab-button>

        <ion-tab-button tab="help-page" href="/help-page">
          <ion-icon aria-hidden="true" :icon="informationCircleOutline" />
          <ion-label>{{$t("navbar.info")}}</ion-label>
        </ion-tab-button>
      </ion-tab-bar>

    </ion-tabs>
  </ion-page>
</template>

<script lang="ts">
import {
  IonButton,
  IonContent,
  IonPage,
  IonIcon,
  IonRouterOutlet,
  IonLabel,
  IonTabButton,
  IonTabs,
  IonTabBar
} from '@ionic/vue';
import { informationCircleOutline, settingsOutline, homeOutline, personOutline } from "ionicons/icons";

export default {
  components: { IonRouterOutlet, IonPage, IonContent, IonIcon, IonButton, IonLabel, IonTabButton, IonTabs, IonTabBar },
  props: {

  },
  data () {
    return {

    }
  },
  setup() {
    return {
      informationCircleOutline,
      settingsOutline,
      homeOutline,
      personOutline
    };
  },
  beforeMount() {

  },
  methods: {

  }
}
</script>

<style>

</style>
